import { AbstractControl, FormGroup, ValidationErrors } from '@angular/forms';

const englishRequired = $localize`Content that is populated in French must be provided in English`;
const frenchRequired = $localize`Content that is populated in English must be provided in French`;

export function pairEnFr(group: AbstractControl): ValidationErrors | null {
  const englishFormCtl = (group as FormGroup).controls.en;
  const frenchFormCtl = (group as FormGroup).controls.fr;

  if (!englishFormCtl.value && !!frenchFormCtl.value) {
    englishFormCtl.setErrors({ englishRequired: englishRequired });
    return { englishRequired: englishRequired };
  } else if (!frenchFormCtl.value && !!englishFormCtl.value) {
    frenchFormCtl.setErrors({ frenchRequired: frenchRequired });
    return { frenchRequired: frenchRequired };
  } else if (!frenchFormCtl.value && !englishFormCtl.value) {
    // unset the errors because if neither of them are filled then neither of them need to be filled
    englishFormCtl.setErrors(null);
    frenchFormCtl.setErrors(null);
  } // else the form ctls could be valid or pending or disabled
  return null;
}

export function bothEnFr(group: AbstractControl): ValidationErrors | null {
  const englishFormCtl = (group as FormGroup).controls.en;
  const frenchFormCtl = (group as FormGroup).controls.fr;

  const formGroupErrors: ValidationErrors = {};
  if (!englishFormCtl.value) {
    englishFormCtl.setErrors({ required: true });
    formGroupErrors.englishRequired = englishRequired;
  }
  if (!frenchFormCtl.value) {
    frenchFormCtl.setErrors({ required: true });
    formGroupErrors.frenchRequired = frenchRequired;
  }
  return Object.keys(formGroupErrors).length <= 0 ? null : formGroupErrors;
}

export function groupEnFr(control: AbstractControl): ValidationErrors | null {
  const group = control as FormGroup;
  let errors = {};
  for (const controlsKey in group.controls) {
    const subGroup = group.controls[controlsKey];
    if (subGroup.hasError('englishRequired')) errors = { ...errors, englishRequired: true };
    if (subGroup.hasError('frenchRequired')) errors = { ...errors, frenchRequired: true };
  }
  return Object.keys(errors).length === 0 ? null : errors;
}
